<div class="appbased-tv__compatible-devices">
  <button
      ds-button
      [attr.aria-label]="'global.activation.viewCompatibleDevicesAlt' | translate"
      [attr.title]="'global.activation.viewCompatibleDevices' | translate"
      [variant]="CTATypes.TERTIARY"
      class="mb-40"
      (click)="openModal(compatibleDevicesModal)">
    {{ 'global.activation.viewCompatibleDevices' | translate }}
  </button>

  <ng-template #compatibleDevicesModal>
    <ds-modal
        [heading]="' '"
        [closeCaption]="'global.modals.compatible-devices.closeA11y' | translate"
        [size]="'large'"
        (closeClick)="closeModal()">
      <div body>
        <div class="appbased-tv__compatible-devices__body">
          <h1 class="text-title-3">{{'global.modals.compatible-devices.header' | translate}}</h1>
          <p [innerHTML]="'global.modals.compatible-devices.description' | translate"></p>
          <div [innerHTML]="'global.modals.compatible-devices.message' | translate"></div>
          <button
              ds-button
              [attr.aria-label]="'global.modals.compatible-devices.closeA11y' | translate"
              [attr.title]="'global.modals.compatible-devices.cancel' | translate"
              [variant]="CTATypes.TERTIARY"
              (click)="closeModal()">
            <span aria-hidden="true">{{ 'global.modals.compatible-devices.cancel' | translate }}</span>
          </button>
        </div>
      </div>
    </ds-modal>
  </ng-template>
</div>